/**
 * Centralized API configuration
 * All business API routes should start with /api/
 */
// Same-origin in every build: the SPA is served by the backend that answers
// its API (the admin app, or a tenant container). The env override exists for
// `npm start` against a separately running backend and is ignored in
// production builds, so one artifact can be promoted between environments.
const DEV_BASE = process.env.NODE_ENV === 'development' ? (process.env.REACT_APP_ADMIN_API_BASE_URL || '') : '';

/**
 * Base URL for non-business APIs (e.g., authentication, /runtime-config)
 * These routes should NOT include /api/
 */
export const BASE_URL = DEV_BASE;

export const API_BASE_URL = DEV_BASE + '/api';

